import React from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

import AddUser from './addUser.js';

import users from './../../../assets/images/svg/114-users.svg';
import bank from './../../../assets/images/svg/115-bank.svg';
import cash from './../../../assets/images/svg/116-cash.svg';
import employee from './../../../assets/images/svg/108-employee.svg';
import file from './../../../assets/images/svg/101-file.svg';

export const Header = () => {
	const router = useSelector(state => state.router);
	return (
		<div className="container-fluid">			
			<nav className="navbar navbar-expand-lg navbar-light px-0 mb-2">
				<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="btn-alert-secondary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
					<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
				</button>
				<div className="collapse navbar-collapse flex-column" id="navbarNav">
					<hr className="d-lg-none" />
					<ul className="nav nav-fill nav-pills bg-lg-dim rounded-max">
						<NavLink exact to="/partner/settings" activeClassName="bg-secondary text-white" className="nav-item w-auto text-uppercase rounded-inherit">
							<div className="nav-link py-1">Profil de l'utilisateur</div>
						</NavLink>
						<div className="w-100 mt-1 d-sm-none"></div>
						<NavLink to="/partner/settings/securite" activeClassName="bg-secondary text-white" className="nav-item w-auto text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Securité</div>
						</NavLink>
						<div className="w-100 mt-2 d-sm-none"></div>
						<a href="#" className="nav-item w-auto text-uppercase rounded-inherit mr-lg-0 disabled">
						<div className="nav-link py-1 px-0 px-xl-3">permission <span className="d-md-none d-xl-inline-block">utilisateur</span></div>
						</a>
						{/* <NavLink exact to="/partner/settings/users" disabled={true} activeClassName="bg-secondary text-white" className="nav-item w-auto text-uppercase rounded-inherit mr-lg-0 disabled">
							<div className="nav-link py-1 px-0 px-xl-3">permission <span className="d-md-none d-xl-inline-block">utilisateur</span></div>
						</NavLink> */}
					</ul>
					<hr className="d-lg-none mb-0" />
				</div>
			</nav>
		</div>
	)
}